import React from "react";

const TourType = () => {
  return (
    <div className="my-5">
      <div className="md:flex justify-center py-3 types ">
        <li className="px-3 text-2xl text-teal-500">Nature Addicts</li>
        <li className="px-3 text-2xl text-teal-500">Fresh Air Lovers</li>
        <li className="px-3 text-2xl text-teal-500">Road Trips</li>
        <li className="px-3 text-2xl text-teal-500">Mountain tour</li>
        <li className="px-3 text-2xl text-teal-500">Camp tour</li>
        <li className="px-3 text-2xl text-teal-500">Hill tour</li>
        <li className="px-3 text-2xl text-teal-500">Sunset tour</li>
        <li className="px-3 text-2xl text-teal-500">Hiking tour</li>
      </div>
    </div>
  );
};

export default TourType;
